import { uuid25 } from "../../uuid/dist/uuid25.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/index.entity.ts
var createIndex = (value) => deepMerge({
	id: uuid25(),
	name: "",
	tableId: "",
	indexColumnIds: [],
	seqIndexColumnIds: [],
	unique: false
}, value ?? {});
//#endregion
export { createIndex };
